import Select, { SelectProps } from '@justgiving/select';
import '@justgiving/select/src/Select.scss';
import React, { FunctionComponent } from 'react';
import styles from './FormSelect.scss';
import FormGroup, { FormGroupProps } from '../FormGroup/FormGroup';
import cn from 'classnames';

export type FormSelectProps = SelectProps & FormGroupProps;

const FormSelect: FunctionComponent<FormSelectProps> = ({
  onChange,
  placeholder,
  items,
  className,
  ...props
}) => {
  return (
    <FormGroup className={cn(styles.formSelect, className ?? '')} {...props}>
      <Select items={items} placeholder={placeholder} onChange={onChange} />
    </FormGroup>
  );
};

export default FormSelect;
